<template>
  <div id="item">
    <bread :content="breadContent"></bread>
    <p class="Page-title">研究项目</p>
    <el-divider></el-divider>
    <table border="1" cellspacing="0">
      <tr>
        <td class="table-head">项目名称</td>
        <td class="table-head">项目来源</td>
        <td class="table-head">批准时间</td>
      </tr>
      <tr v-for="(item, index) in showTable" :key="index">
        <td>
          <table border="0" cellspacing="0">
            <td class="setBorder" style="border-right:1.5px #404040 solid;width:60px">
              {{index + 1}}
            </td>
            <td>
              {{item.Title}}
            </td>
          </table>
        </td>
        <td class="table-item">{{item.Source}}</td>
        <td class="table-item">{{item.Date}}</td>
      </tr>
    </table>
    <el-pagination class="page" background layout="prev, pager, next,jumper" :total="tableData.length" :page-size="16" @current-change="handleCurrentChange" :current-page="tableIndex">
    </el-pagination>
  </div>
</template>
<script>
import bread from "@/components/bread";
import Api from "@/network.js";
export default {
  name: "item",
  components: {
    bread
  },
  data() {
    return {
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "中心概况", routerName: "introduce" },
        { text: "科学研究", routerName: "direction" },
        { text: "研究项目", routerName: "item" }
      ],
      showTable: [],
      tableData: [],
      tableIndex: 1
    };
  },
  async beforeRouteEnter(to, from, next) {
    let res = (await Api.introduce.getItem()) || [];
    next(async vm => {
      vm.$data.tableData = res;
      vm.$data.showTable = vm.$data.tableData.slice(0, 16);
    });
  },
  methods: {
    handleCurrentChange(index) {
      this.showTable = this.tableData.slice((index - 1) * 16, index * 16);
    }
  }
};
</script>
  
<style lang="scss" scoped>
#item {
  display: block;
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}
.table-head {
  font-weight: 700;
  padding: 20px 0;
}
.setBorder {
  padding: 15px 0;
}
.test{
  padding: 15px 0;
}
table {
  padding: 0;
  width: 95%;
  text-align: center;
  td {
    font-size: 22px;
  }
}
.index{
  border:1px red solid;
}
.page {
  transform: scale(1.3);
  text-align: center;
  margin-top: 50px;
}
</style>



